import { Box, Typography } from '@mui/material';
import { DropDown } from 'common/ui';
import { formatToUSDate } from 'utils/datetime';
import { stageOptions } from '../constants/stageOptions';
import { ApplicationStage } from '../types';
import { conversationMessagingDetailsSx } from '../styles';

type Props = {
  value?: ApplicationStage;
  lastUpdatedAt?: string | null;
  isLoading: boolean;
  onChange: (value: string) => void;
};

export const ConversationApplicationStage: React.FC<Props> = ({
  value,
  lastUpdatedAt,
  isLoading,
  onChange
}) => (
  <Box sx={conversationMessagingDetailsSx.stageBlock}>
    <Box sx={conversationMessagingDetailsSx.stageHeading}>
      <Typography sx={conversationMessagingDetailsSx.stageLabel}>
        Application stage
      </Typography>
      {lastUpdatedAt && (
        <Typography sx={conversationMessagingDetailsSx.stageHint}>
          Last updated {formatToUSDate(lastUpdatedAt)}.
        </Typography>
      )}
    </Box>
    <Box sx={conversationMessagingDetailsSx.stageSelect}>
      <DropDown
        value={value}
        onChange={onChange}
        options={stageOptions}
        showValueChosenIcon
        placeholder="Select"
        isLoading={isLoading}
      />
    </Box>
  </Box>
);
